import { RecordRepository, UserRepository } from "../../api";
import conversor from "json-2-csv";

import { Auth } from "../../models/lib/entities/Auth";

export class MainController {
	constructor(context) {
		this.navigateToPassword = this.navigateToPassword.bind(context);
		this.linkMenu = this.linkMenu.bind(context);
		this.logout = this.logout.bind(context);
		this.navigateToHome = this.navigateToHome.bind(context);
		this.navigateToReport = this.navigateToReport.bind(context);
		this.donwloadAction = this.donwloadAction.bind(context);
		this.downloadCsv = this.downloadCsv.bind(this);

		this.recordRepo = new RecordRepository();
		this.usersRepo = new UserRepository();
	}
	
	navigateToPassword() {
		this.props.router.push("/password");
	}
	
	showIeMessage() {
		const targetClick = document.querySelectorAll("a[href='#ie']");
		targetClick[0].click();
	}
	
	showAboutUs() {
		const targetClick = document.querySelectorAll("a[href='#aboutUs']");
		targetClick[0].click();
	}
	
	navigateToReport() {
		if (!this.props.auth.isDone("mensuration") || !this.props.auth.isDone("menagement") || !this.props.auth.isDone("comunication")) 
		return Materialize.toast("Antes de acessar o relatório, termine todos os formularios.", 4000);
		return this.props.router.push("/report");
	}

	navigateToHome() {
		this.props.router.push("/dashboard");
	}
	
	logout() {
		const auth = new Auth({});
		this.props.setAuthAction(auth);
		window.sessionStorage.removeItem("session_token");
		this.props.router.push("/");
	}
	
	linkMenu(e) {
		const target = e.currentTarget.id;
		if(this.props.auth.isDone(target.slice(1))) return;
		if(name == "disabled") return;
		else {
			const targetClick = document.querySelectorAll("a[href='"+target+"']");
			targetClick[0].click();
		}
	}

	async fetchComunications() {
		const record = await this.recordRepo.getComunication("token");
		const comunication = [];
		for (let i in record.data) {
			const response = await this.mapComunication(record.data[i], record.data[i].user_id);
			comunication.push(response);
		}
		return comunication;
	}
	
	async fetchMensurations() {
		const record = await this.recordRepo.getMensuration("token");
		const mensuration = [];
		for(let i in record.data) {
			const response = await this.mapMensuration(record.data[i], record.data[i].user_id);
			mensuration.push(response);
		}
		return mensuration;
	}
		
	async fetchManagement() {
		const record = await this.recordRepo.getManagement("token");
		const management = [];
		for (let i in record.data) {
			const response = await this.mapManagement(record.data[i], record.data[i].user_id);
			management.push(response);
		}
		return management;
	}

	async downloadComunication() {
		const record = await this.fetchComunications();
		await this.downloadCsv(record, "relatorio_de_comunicacao");
	}
	async downloadMensurations() {
		const record = await this.fetchMensurations();
		await this.downloadCsv(record, "relatorio_de_mensuracao");
	}
	async downloadManagement() {
		const record = await this.fetchManagement();
		await this.downloadCsv(record, "relatorio_de_gestao");
	}
	
	
	async donwloadAction(type) {
		switch(type){
			case "comunication": return this.controller.downloadComunication();
			case "mensuration": return this.controller.downloadMensurations();
			case "management": return this.controller.downloadManagement();
		}
	}

	async mapComunication(form, userId) {
		const user = await this.usersRepo.getOne(userId, { email: 1 });
		return {
				"usuarios: \\ questões:": user.data.email,
				"3.1"		: "Alternativa: " + form.engagement["1"],
				"3.2"		: "Alternativa: " + form.engagement["2"],
				"3.3"		: "Alternativa: " + form.engagement["3"],
				"3.4"		: "Alternativa: " + form.engagement["4"],
				"3.1.1"	: form.engagement["1-1"] || "-",
				"3.2.1"	: form.engagement["2-1"] || "-",
				"3.5"		: "Alternativa: " + form.comunication["1"],
			};
	}
	
	async mapManagement(form, userId) {
		const user = await this.usersRepo.getOne(userId, { email: 1 });
		return {
				"usuario: \\ questões:": user.data.email,
				"2.1"		: form.governanceResponsibilities["1"] ? "Alternativa: " + form.governanceResponsibilities["1"] : "-",
				"2.2"		: form.governanceResponsibilities["2"] ? "Alternativa: " + form.governanceResponsibilities["2"] : "-",
				"2.3"		: form.governanceResponsibilities["3"] ? "Alternativa: " + form.governanceResponsibilities["3"] : "-",
				"2.3.1"	: form.governanceResponsibilities["3-1"] || "-",
				"2.4"		: form.governanceResponsibilities["4"] ? "Alternativa: " + form.governanceResponsibilities["4"] : "-",
				"2.4.1"	: form.governanceResponsibilities["4-1"] || "-",
				"2.5"		: form.businessPlanning["1"] ? "Alternativa: " + form.businessPlanning["1"] : "-",
				"2.5.1"	: form.businessPlanning["1-1"] || "-",
			};
	}
	
	async mapMensuration(form, userId) {
		const user = await this.usersRepo.getOne(userId, { email: 1 });
		return {
			"usuario: \\ questões:": user.data.email,
			"1.1.1"		: this.monthConversor(form.waterTreatment["1"]),
			"1.1.1.2"	: 
				"Água Superficial (Rios / Lagos): "+(form.waterTreatment["2-1"].aboveGroundWater || "0")
				+" | Água Subterrâneas (Lençóis Freáticos/ Aquíferos): "+(form.waterTreatment["2-1"].subterraneanWater || "0") 
				+" | Abastecimento público (COPASA): "+(form.waterTreatment["2-1"].publicSupply || "0")
				+" | Água de chuva: "+(form.waterTreatment["2-1"].rainWater || "0")
				+" | Água de reúso / reaproveitamento: "+(form.waterTreatment["2-1"].reusedWater || "0"),

			"1.1.1.3"	: form.waterTreatment["2-2"] || "-",
			"1.1.2"		: form.waterTreatment["3"] || form.waterTreatment["3"] == 0 ? form.waterTreatment["3"] : "-",
			
			//measurementSectorization
			"1.2.1"		: form.measurementSectorization["1"] ? "SIM" : "NÃO",
			"1.2.1.2"	: form.measurementSectorization["1-1"] || "-",
			"1.2.1.3"	: 
				"Estimativa por técnicos da empresa" + form.measurementSectorization["1-2"].E
				+ "Medição real com hidrômetros setorizados em cada área e anotação manual por técnicos da empresa" + form.measurementSectorization["1-2"].M
				+ "Medição real com hidrômetros inteligentes que enviam dados em tempo real para um computador" + form.measurementSectorization["1-2"].A,
			"1.2.1.4"	: 
				"Estimativa por técnicos da empresa" + form.measurementSectorization["1-3"].E
				+ "Medição real com hidrômetros setorizados em cada área e anotação manual por técnicos da empresa" + form.measurementSectorization["1-3"].M
				+ "Medição real com hidrômetros inteligentes que enviam dados em tempo real para um computador" + form.measurementSectorization["1-3"].A,
			//effluentTreatment
			"1.3.1"		: this.monthConversor(form.effluentTreatment["1"]),
			"1.3.2"		: form.effluentTreatment["2"] ? "Alternativa: " + form.effluentTreatment["2"] : "-",
			"1.4.2.2"	: "Alternativas: " + (form.effluentTreatment["2-1"] ? form.effluentTreatment["2-1"].join("-") : "-"),
			"1.3.2.3"	: form.effluentTreatment["2-2"] || "-",
			"1.3.2.1"	: form.effluentTreatment["2-3"] || form.effluentTreatment["2-3"] == 0 ? form.effluentTreatment["2-3"] : "-",
			"1.4.4"		: form.effluentTreatment["2-4"] ? "SIM"  : "NÃO",
			"1.4.4.1"	: 
				"DBO: " + form.effluentTreatment["2-5"].DBO
				+ " | NAT: " + form.effluentTreatment["2-5"].NAT,
			//finalProduct
			"1.4.1"	: form.finalProduct["1"] || "-",
			"1.4.2"	: form.finalProduct["2"] || "-",
			"1.4.3": this.monthConversorWithNumber(form.finalProduct["3"]),
			// input
			"Insumos produto 1"	: this.convertInputItem(form.input[0] || {}),
			"Insumos produto 2"	: this.convertInputItem(form.input[1] || {}),
			"Insumos produto 3"	: this.convertInputItem(form.input[2] || {}),
			"1.6.1"		: form.others["1"] ? "SIM"  : "NÃO",
			"1.6.2"		: form.others["2"] ? "SIM"  : "NÃO",
			"1.6.2.1"	: form.others["2-1"] ? "SIM" : "NÃO",
			"1.6.3"		: form.others["3"] ? "SIM"  : "NÃO",
			"1.6.4"		: form.others["4"] ? "SIM"  : "NÃO",
		};
	}

	convertInputItem(obj) {
		let str = "";
		
		str += "Produto: " + (obj[1] || "-") 
			+ " Unidade de medida: " + (obj[2] || "-") 
			+ " insumo utilizado: " + (obj[3] || "-") 
			+ " origem: UF" + (obj[4] ? obj[4].state : "-") + " Cidade: " + (obj[4] ? obj[4].country : "-");
		return str;
	}


	monthConversor(obj) {
		let str = "";
		str += (`jan: ${obj.jan || "-"} | `);
		str += (`fev: ${obj.feb || "-"} | `);
		str += (`mar: ${obj.mar || "-"} | `);
		str += (`abr: ${obj.apr || "-"} | `);
		str += (`mai: ${obj.may || "-"} | `);
		str += (`jun: ${obj.jun || "-"} | `);
		str += (`jul: ${obj.jul || "-"} | `);
		str += (`ago: ${obj.aug || "-"} | `);
		str += (`set: ${obj.sep || "-"} | `);
		str += (`out: ${obj.oct || "-"} | `);
		str += (`nov: ${obj.nov || "-"} | `);
		str += (`dez: ${obj.dec || "-"}`);
		return str;
	}
	
	monthConversorWithNumber(obj) {
		let str = "";
		str += (`jan: ${obj.jan.number || "-"} | `);
		str += (`fev: ${obj.feb.number || "-"} | `);
		str += (`mar: ${obj.mar.number || "-"} | `);
		str += (`abr: ${obj.apr.number || "-"} | `);
		str += (`mai: ${obj.may.number || "-"} | `);
		str += (`jun: ${obj.jun.number || "-"} | `);
		str += (`jul: ${obj.jul.number || "-"} | `);
		str += (`ago: ${obj.aug.number || "-"} | `);
		str += (`set: ${obj.sep.number || "-"} | `);
		str += (`out: ${obj.oct.number || "-"} | `);
		str += (`nov: ${obj.nov.number || "-"} | `);
		str += (`dez: ${obj.dec.number || "-"}`);
		return str;
	}

	async downloadCsv(array, fileName) {
		conversor.json2csv(array, 
			(e, csv) => {
				this.createCSV(csv, `${fileName}.csv`, "text/csv");
				return;
			}
		);
	}

	createCSV(content, fileName, mimeType) {
		var a = document.createElement("a");

		mimeType = mimeType || "application/octet-stream";

		if (navigator.msSaveBlob) { // IE10

			return navigator.msSaveBlob(new Blob([content], { type: mimeType }), fileName);

		} else if ("download" in a) { //html5 A[download]

			var blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
			const url = URL.createObjectURL(blob);
			a.setAttribute("href", url);
			a.setAttribute("download", fileName);
			a.style.visibility = "hidden";
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);

		} else { //do iframe dataURL download (old ch+FF):

			var f = document.createElement("iframe");
			document.body.appendChild(f);
			f.src = "data:" + mimeType + "," + encodeURIComponent(content);

			setTimeout(function () {
				document.body.removeChild(f);
			}, 333);

			return true;

		}
		return;
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/MainController.js